var kind      = require("enyo/kind"),
    themeVars = require("app/theme/variables.js");

require("./Background.less");

module.exports = kind(/** @lends app.AppLayout.Background.prototype */ {

    /**
     * @private
     */
    name: "app.AppLayout.Background",

    /**
     * @private
     */
    classes: "app-app-layout-background enyo-fit",

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.generateBackground();
        };
    }),

    /**
     * Generate a css background
     *
     * @private
     */
    generateBackground: function() {
        var numPoints        = 8,
            baseHues         = themeVars.backgroundBaseHues,
            numColorVariants = Math.ceil(numPoints / baseHues.length),
            points           = this.distributePoints(100, 100, numPoints),
            colors           = [],
            gradients;

        baseHues.forEach(this.bindSafely(function(baseHue) {
            colors = colors.concat(this.generateSimilarColors(baseHue, numColorVariants));
        }));
        gradients = this.generateRadialCssGradients(points, colors);

        this.addStyles({
            background: gradients.join(", ")
        });
    },

    /**
     * Distributes points randomly within the given area, taking into account a
     * required minimum distance between the points.
     *
     * @param    {number}  width      The width of the area,
     * @param    {number}  height     The height of the area,
     * @param    {number}  numPoints  The amount of points
     * @returns  {Array}   An array of points
     * @private
     */
    distributePoints: function(width, height, numPoints) {
        var points           = [],
            totalAttempts    = 0,
            maxTotalAttempts = 30 * numPoints; // Max attempts is 30 times number of points

        /**
         * Helper function to calculate distance between two points
         *
         * @param    {Object}  point1  The first point
         * @param    {Object}  point2  The second point
         * @returns  {number}  The distance
         */
        function distance(point1, point2) {
            return Math.sqrt(Math.pow((point1.x - point2.x), 2) + Math.pow((point1.y - point2.y), 2));
        }

        /**
         * Helper function to add a point only if it meets distance criteria.
         *
         * @returns  {boolean}  Whether a point was added
         */
        function tryAddPoint() {
            var attempt,
                newPoint,
                i,
                dynamicRadius = 100 / Math.sqrt(numPoints) * 0.5,
                tooClose;

            for (attempt = 0; attempt < 30; attempt++) {
                totalAttempts++;

                newPoint = {
                    x: Math.random() * width,
                    y: Math.random() * height
                };

                // Invalidate new point if it is too close to another one
                for (i = 0; i < points.length; i++) {
                    if (distance(points[i], newPoint) < dynamicRadius) {
                        tooClose = true;
                        break;
                    }
                }

                if (!tooClose || points.length === 0) {
                    points.push(newPoint);

                    return true; // Successfully added a new point
                }
            }

            return false; // Failed to add a new point after 30 attempts
        }

        // Try adding points until we have enough or we fail to add more
        while (points.length < numPoints && totalAttempts < maxTotalAttempts) {
            tryAddPoint();
        }

        return points;
    },

    /**
     * Create a set of colors with a hue similar to the one provided.
     *
     * @param    {number}  referenceHue  The reference hue
     * @param    {number}  numColors     The amount of colors
     * @returns  {Array}   The generate colors
     * @private
     */
    generateSimilarColors: function(referenceHue, numColors) {
        var colors = [],
            i,
            newHue,
            saturation,
            luminance,
            newColor;

        for (i = 0; i < numColors; i++) {
            // Adjust hue by up to +/- 60 degrees
            newHue = (360 + Number(referenceHue) + (Math.random() - 0.5) * 60) % 360;

            // Saturation in 25-50% range
            saturation = 25 + Math.random() * 25;

            // Luminance in 5-15% range
            luminance = 7 + Math.random() * 10;

            // Form the new HSL color string
            newColor = "hsl(" + newHue.toFixed(0) + ", " + saturation.toFixed(0) + "%, " + luminance.toFixed(0) + "%)";
            colors.push(newColor);
        }

        return colors;
    },

    /**
     * Generate css gradients for each of the points, picking a color out of the
     * set for each point.
     *
     * @param    {Array<Object>}  points  The points
     * @param    {Array<string>}  colors  The colors
     * @returns  {Array<string>}  The generated gradients
     * @private
     */
    generateRadialCssGradients: function(points, colors) {
        var xPercent,
            yPercent,
            rx,
            ry,
            gradients = [],
            i;

        for (i = 0; i < points.length; i++) {
            xPercent = (points[i].x).toFixed(2);
            yPercent = (points[i].y).toFixed(2);
            rx       = (33 + Math.random() * 66).toFixed(2);
            ry       = (33 + Math.random() * 66).toFixed(2);

            // CSS for elliptical gradient
            gradients.push("radial-gradient(ellipse at " + xPercent + "% " + yPercent + "%, " + colors[i] + ", rgba(255, 255, 255, 0) " + rx + "%, rgba(255, 255, 255, 0) " + ry + "%)");
        }

        return gradients;
    }

});
